import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { getAideIndustrieStub } from '../../../../config/aides-industrie';

export default function CoupsDePoucePage() {
  const aide = getAideIndustrieStub('coups-de-pouce');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="industrie" />;
}
